import { Client, Account, ID } from "appwrite"; // Import necessary Appwrite components
import { createDocument } from '../lib/appwrite'; // Import createDocument function

import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";

const client = new Client();
const account = new Account(client);

const Login = () => {
  const API_URL = process.env.API_URL;
  const navigate = useNavigate();
  const [registered, setRegistered] = useState(true);
  const [loginInfo, setLoginInfo] = useState({
    name: "",
    username: "",
    password: "",
  });
  const userInfo = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    if (!userInfo) {
      return;
    } else {
      navigate("/profile");
    }
  }, []);

  const register = async () => {
    const number = Math.random();
    const intiger = Math.floor(number * 100); // Ensure it's a valid integer

    const percentage = intiger.toString().substring(0, 4);
    try {
      console.log("Registering with data:", { name: loginInfo.name, username: loginInfo.username, password: loginInfo.password, rc_score: percentage });

const response = await createDocument({ 
    user_id: intiger, 
    user_name: loginInfo.username, 
    password: loginInfo.password, 
    name: loginInfo.name 
});




      console.log(response);
      toast.success("You Have Been Registered");
      setLoginInfo({
        name: "",
        username: "",
        password: "",
      });
      setRegistered(true);
      return;
    } catch (error) {
      const errorMessage = error.response && error.response.data ? error.response.data.message : "An error occurred during registration.";

      toast.error(errorMessage);
    }
  };

  const login = async () => {
    try {
      const response = await account.createEmailSession(loginInfo.username, loginInfo.password);
      localStorage.setItem("userData", JSON.stringify(response));
      toast.success("You Have Been Logged");
      window.location.reload();
      setRegistered(true);
      return;
    } catch (error) {
      toast.error("Incorrect username or password.");
    }
  };
  //
  //
  //
  return (
  <section className="flex w-[100vw] flex-col">
  <div className="contactbg flex items-center justify-center min-h-screen">
    <div className="w-[90%] max-w-[450px] p-8 bg-gradient-to-br from-[#dec0aa] to-[#e8d1c0] rounded-2xl shadow-2xl">
      <div className="flex flex-col space-y-6">
        <h2 className="text-2xl font-semibold text-[#026305] text-center mb-6">
          {registered ? 'Welcome Back' : 'Create Account'}
        </h2>
        
        {!registered && (
          <div className="relative group">
            <input
              value={loginInfo.name}
              onChange={(e) => setLoginInfo({ ...loginInfo, name: e.target.value })}
              type="text"
              placeholder="Name"
              className="w-full px-4 py-3 bg-gradient-to-r from-[#e8d1c0] to-[#f0dccb] 
              border-b-2 border-[#fbbf3c] text-[#4a3828] placeholder:text-[#8b6f5c] 
              focus:outline-none focus:border-[#c2973a] transition-all duration-300
              font-medium rounded-t-lg"
            />
            <div className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-[#fbbf3c] to-[#c2973a] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"/>
          </div>
        )}

        <div className="relative group">
          <input
            value={loginInfo.username}
            onChange={(e) => setLoginInfo({ ...loginInfo, username: e.target.value })}
            type="text"
            placeholder="Username"
            className="w-full px-4 py-3 bg-gradient-to-r from-[#e8d1c0] to-[#f0dccb] 
            border-b-2 border-[#fbbf3c] text-[#4a3828] placeholder:text-[#8b6f5c] 
            focus:outline-none focus:border-[#c2973a] transition-all duration-300
            font-medium rounded-t-lg"
          />
          <div className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-[#fbbf3c] to-[#c2973a] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"/>
        </div>

        <div className="relative group">
          <input
            value={loginInfo.password}
            onChange={(e) => setLoginInfo({ ...loginInfo, password: e.target.value })}
            type="password"
            placeholder="Password"
            className="w-full px-4 py-3 bg-gradient-to-r from-[#e8d1c0] to-[#f0dccb] 
            border-b-2 border-[#fbbf3c] text-[#4a3828] placeholder:text-[#8b6f5c] 
            focus:outline-none focus:border-[#c2973a] transition-all duration-300
            font-medium rounded-t-lg"
          />
          <div className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-[#fbbf3c] to-[#c2973a] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"/>
        </div>

        <button
          onClick={() => registered ? login() : register()}
          className="w-full mt-6 py-3 bg-[#fbbf3c] hover:bg-[#c2973a] 
          text-white font-medium rounded-lg transform hover:scale-[1.02] 
          transition-all duration-300 shadow-lg"
        >
          {registered ? 'Login' : 'Register'}
        </button>

        <div className="text-center mt-4">
          <p
            className="text-white text-[16px] cursor-pointer"
            onClick={() => setRegistered(!registered)}
          >
            {registered ? (
              <><span className="text-[#181510]">New user? </span><span className="text-[#026305] hover:text-[#302100] underline cursor-pointer transition-all duration-300">Sign Up</span></>
            ) : (
              <> <span className="text-[#181510]"> Existing user? </span> <span className="text-[#026305] hover:text-[#302100] underline cursor-pointer transition-all duration-300">Sign in</span></>
            )}
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
  );
};
export default Login;
